import { expedienteMedidaService } from "@/_services";
export const expedienteMedida = {
  namespaced: true,
  state: {
    list: {
      data: [],
      status: {},
    },
    post: {
      data: [],
      status: {},
    },
    entity: {
      data: {},
      status: {},
    },
    excel: {
      data: {},
      status: {},
    },
    patch: {
      data: {},
      status: {},
    },
  },
  mutations: {
    getExpedientesMedidasRequest(state) {
      state.list.status = {
        loading: true,
      };
    },
    getExpedientesMedidasSuccess(state, response) {
      state.list.data = response;
      state.list.status = {
        loaded: true,
      };
    },
    getExpedientesMedidasError(state, error) {
      state.list.data = null;
      state.list.status = {
        error,
      };
    },
    postExpedienteMedidaRequest(state) {
      state.post.status = {
        creating: true,
      };
    },
    postExpedienteMedidaError(state, error) {
      state.post.data = null;
      state.post.status = {
        error,
      };
    },
    postExpedienteMedidaSuccess(state, response) {
      state.post.data = response;
      state.post.status = {
        created: true,
      };
    },
    getExpedienteMedidaByIdRequest(state) {
      state.entity.status = {
        loading: true,
      };
    },
    getExpedienteMedidaByIdSuccess(state, response) {
      state.entity.data = response;
      state.entity.status = {
        loaded: true,
      };
    },
    getExpedienteMedidaByIdError(state, error) {
      state.entity.data = null;
      state.entity.status = {
        error,
      };
    },
    excelRequest(state) {
      state.excel.status = {
        downloading: true,
      };
    },
    excelSuccess(state, pdf) {
      state.excel.data = pdf;
      state.excel.status = {
        downloaded: true,
      };
    },
    excelError(state, error) {
      state.excel.data = null;
      state.excel.status = {
        error,
      };
    },
    putExpedienteMedidaRequest(state) {
      state.patch.status = {
        changing: true,
      };
    },
    putExpedienteMedidaSuccess(state, response) {
      state.patch.data = response;
      state.patch.status = {
        changed: true,
      };
    },
    putExpedienteMedidaError(state, error) {
      state.patch.data = null;
      state.patch.status = {
        error,
      };
    },
  },
  actions: {
    getExpedientesMedidas({ commit }, request) {
      commit("getExpedientesMedidasRequest");
      expedienteMedidaService
        .getExpedientesMedidas(request.pagination, request.filters)
        .then((response) => {
          commit("getExpedientesMedidasSuccess", response);
        })
        .catch((error) => {
          commit("getExpedientesMedidasError", error);
        });
    },
    postExpedienteMedida({ commit }, request) {
      commit("postExpedienteMedidaRequest");
      expedienteMedidaService
        .postExpedienteMedida(request)
        .then((res) => {
          commit("postExpedienteMedidaSuccess", res);
        })
        .catch((error) => {
          commit("postExpedienteMedidaError", error);
        });
    },
    getExpedienteMedidaById({ commit }, id) {
      commit("getExpedienteMedidaByIdRequest");
      expedienteMedidaService
        .getExpedienteMedidaById(id)
        .then((res) => {
          commit("getExpedienteMedidaByIdSuccess", res);
        })
        .catch((error) => {
          commit("getExpedienteMedidaByIdError", error);
        });
    },
    getExcel({ commit }, filters) {
      commit("excelRequest");
      expedienteMedidaService
        .getExcel(filters)
        .then((excel) => {
          commit("excelSuccess", excel);
        })
        .catch((error) => {
          commit("excelError", error);
        });
    },
    putExpedienteMedida({ commit }, request) {
      commit("putExpedienteMedidaRequest");
      expedienteMedidaService
        .putExpedienteMedida(request.id, request.body)
        .then((res) => {
          commit("putExpedienteMedidaSuccess", res);
        })
        .catch((error) => {
          commit("putExpedienteMedidaError", error);
        });
    },
  },
};
